module.exports = __webpack_public_path__ + "static/media/journey-level-5-bottom.e95068d6.png";